"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _router = require("@reach/router");

var _DeploymentBadge = _interopRequireDefault(require("./DeploymentBadge"));

var _AvatarMenu = _interopRequireDefault(require("./AvatarMenu"));

var _LanguageSwitcher = _interopRequireDefault(require("./LanguageSwitcher"));

var _redux = require("../redux");

var _routes = _interopRequireDefault(require("../routes"));

var _templateObject, _templateObject2, _templateObject3;

var messages = {
  'undeployed-changes': {
    onClick: function onClick() {
      return (0, _router.navigate)((0, _routes.default)('dashboard'));
    },
    title: 'Unpublished changes',
    description: 'Click the deployment button to publish the latest updates.'
  },
  'missing-front-page': {
    onClick: function onClick() {
      return (0, _router.navigate)((0, _routes.default)('collection', {
        postTypeID: 'page'
      }));
    },
    title: 'Homepage missing',
    description: 'Assign the homepage attribute within the page settings to any page.'
  },
  'unpublished-front-page': {
    onClick: function onClick() {
      return (0, _router.navigate)((0, _routes.default)('collection', {
        postTypeID: 'page'
      }));
    },
    title: 'Homepage not published',
    description: "The homepage status is set to draft or trash and therefore won't get included in the build."
  },
  'untranslated-front-page': {
    onClick: function onClick() {
      return (0, _router.navigate)((0, _routes.default)('collection', {
        postTypeID: 'page'
      }));
    },
    title: 'Homepage translation missing',
    description: 'Translate the homepage into all languages.'
  }
};

var CmsHeader = function CmsHeader(props) {
  var _site$postTypes, _site$postTypes$page, _site$postTypes$page$, _site$postTypes$page$2, _site$languages, _site$errors;

  var title = props.title;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      site = _ref.cms.site;

  var deployment = site === null || site === void 0 ? void 0 : site.deployment;
  var notifications = []; // We're only pushing keys to the notifications array to improve useMemo performance

  if (deployment !== null && deployment !== void 0 && deployment.undeployedChanges) {
    notifications.push('undeployed-changes');
  }

  if (!(site !== null && site !== void 0 && site.frontPage)) {
    notifications.push('missing-front-page');
  }

  if (site !== null && site !== void 0 && site.frontPage && (site === null || site === void 0 ? void 0 : (_site$postTypes = site.postTypes) === null || _site$postTypes === void 0 ? void 0 : (_site$postTypes$page = _site$postTypes['page']) === null || _site$postTypes$page === void 0 ? void 0 : (_site$postTypes$page$ = _site$postTypes$page.posts) === null || _site$postTypes$page$ === void 0 ? void 0 : (_site$postTypes$page$2 = _site$postTypes$page$[site === null || site === void 0 ? void 0 : site.frontPage]) === null || _site$postTypes$page$2 === void 0 ? void 0 : _site$postTypes$page$2.status) !== 'publish') {
    notifications.push('unpublished-front-page');
  } // Check if all languages have a front page assigned


  if (site !== null && site !== void 0 && site.frontPage && site !== null && site !== void 0 && (_site$languages = site.languages) !== null && _site$languages !== void 0 && _site$languages.languages) {
    var _site$postTypes2, _site$postTypes2$page, _site$postTypes2$page2, _site$languages2; // Get all translations of front page


    var frontPagePost = site === null || site === void 0 ? void 0 : (_site$postTypes2 = site.postTypes) === null || _site$postTypes2 === void 0 ? void 0 : (_site$postTypes2$page = _site$postTypes2.page) === null || _site$postTypes2$page === void 0 ? void 0 : (_site$postTypes2$page2 = _site$postTypes2$page.posts) === null || _site$postTypes2$page2 === void 0 ? void 0 : _site$postTypes2$page2[site === null || site === void 0 ? void 0 : site.frontPage]; // Initialize missing translations

    var missingTranslations = []; // Loop through all available languages and check if a translation exist

    site === null || site === void 0 ? void 0 : (_site$languages2 = site.languages) === null || _site$languages2 === void 0 ? void 0 : _site$languages2.languages.map(function (o) {
      return (frontPagePost === null || frontPagePost === void 0 ? void 0 : frontPagePost.language) !== o.slug && !(frontPagePost !== null && frontPagePost !== void 0 && frontPagePost.translations[o.slug]) && missingTranslations.push(o.name);
    });

    if (missingTranslations.length > 0) {
      notifications.push('untranslated-front-page');
    }
  }

  if (site !== null && site !== void 0 && (_site$errors = site.errors) !== null && _site$errors !== void 0 && _site$errors.length) {
    // Add CMS errors
    site.errors.map(function (o) {
      return notifications.push(o.id);
    });
  }

  return (0, _react.useMemo)(function () {
    var _site$languages3;

    var buttons = [];
    site && buttons.push( /*#__PURE__*/_react.default.createElement(_DeploymentBadge.default, {
      key: "deployment-badge",
      deployment: deployment
    }));

    var notificationsContent = /*#__PURE__*/_react.default.createElement(Notifications, null, /*#__PURE__*/_react.default.createElement(_antd.List, {
      itemLayout: "horizontal",
      dataSource: notifications,
      renderItem: function renderItem(key) {
        var item = (messages === null || messages === void 0 ? void 0 : messages[key]) || (site === null || site === void 0 ? void 0 : site.errors.find(function (o) {
          return o.id === key;
        }));
        return /*#__PURE__*/_react.default.createElement(_antd.List.Item, {
          key: key,
          onClick: item.onClick
        }, /*#__PURE__*/_react.default.createElement(_antd.List.Item.Meta, {
          title: item.title,
          description: item.description
        }));
      }
    }));

    buttons.push( /*#__PURE__*/_react.default.createElement(_antd.Popover, {
      key: 'notifications',
      title: "Notifications",
      content: notificationsContent,
      trigger: ['click'],
      placement: "bottomRight"
    }, /*#__PURE__*/_react.default.createElement(_antd.Badge, {
      size: "small",
      count: notifications.length
    }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      icon: /*#__PURE__*/_react.default.createElement(_icons.BellOutlined, null),
      type: "default"
    }))));
    buttons.push( /*#__PURE__*/_react.default.createElement(_AvatarMenu.default, {
      key: "avatar-menu"
    }));

    if (site !== null && site !== void 0 && (_site$languages3 = site.languages) !== null && _site$languages3 !== void 0 && _site$languages3.languages) {
      buttons.push( /*#__PURE__*/_react.default.createElement("div", {
        key: "language-switcher"
      }, /*#__PURE__*/_react.default.createElement(_LanguageSwitcher.default, null)));
    }

    buttons.push( /*#__PURE__*/_react.default.createElement(_router.Link, {
      key: "view-website",
      to: "/"
    }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      children: "View Website"
    })));
    return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_antd.PageHeader, {
      title: title,
      extra: buttons
    })));
  }, [deployment, notifications]);
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  right: 0;\n  width: calc(100% - 250px);\n  height: 50px;\n  background: #fff;\n  border-bottom: 1px solid #d9e1ef;\n"])));

var Content = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  max-width: 1024px;\n  padding: 0 40px;\n  margin: 0 auto;\n"])));

var Notifications = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: 320px;\n"])));

var _default = CmsHeader;
exports.default = _default;